import I18N from '@leverege/i18n';
import CustomTextDetailModel from "./CustomTextDetailModel.js";
const {
  tf
} = I18N.ns('ui-attributes.detail.customText.customTextDetail');
export default {
  name: tf('name'),
  displayName: tf('displayName'),
  create: () => {
    return CustomTextDetailModel.create();
  },
  objectType: '*',
  handles: () => true
};